import * as React from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import IRole from './IRole';
import FormSelect from '../../components/common/FormSelect';

interface IRoleSelectProps {
    onChange: (e: any) => void;
    roles: IRole[];
    role: number;
}

const RoleSelect = (props: IRoleSelectProps) => {
    return (
        <FormGroup>
            <ControlLabel>{Translate('role-select/select-label/role')}</ControlLabel>
            <FormSelect
                name="role"
                value={props.role as any}
                onChange={props.onChange}
                defaultTranslateKey="role-select/select-label/default/select-role"
            >
                {props.roles.map((r: IRole) => {
                    return (
                        <option key={r.id} value={r.id as any}>
                            {Translate(r.name)}
                        </option>
                    );
                })}
            </FormSelect>
        </FormGroup>
    );
};

export default RoleSelect;
